document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('contactForm')
  const messageBox = document.querySelector('.form-message')

  function showMessage(type, text) {
    messageBox.textContent = text
    messageBox.className = `form-message ${type}`
    clearTimeout(messageBox.hideTimer)
    messageBox.hideTimer = setTimeout(() => {
      messageBox.textContent = ''
      messageBox.className = 'form-message'
    }, 5000)
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault()

    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    const formData = new FormData(form)

    // Удаляем поле date_submit из FormData
    formData.delete('date_submit')

    fetch('/backend/contact.php', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          showMessage('success', 'Заявка успешно отправлена')
          form.reset()
        } else {
          showMessage('error', data.message)
        }
      })
      .catch((error) => {
        showMessage('error', 'Ошибка отправки формы')
        console.error('Ошибка:', error)
      })
  })
})
